<template>
  <div>
    <BaseAvatar
      :initials="funeralHome?.initials ?? '##'"
      :ring-color="ringColor"
      :shadow-color="shadowColor"
      :size="size"
      :img-url="funeralHome?.logo_url ?? null"
      :tint="funeralHome?.color ?? null"
      hide-status
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseAvatar from '@c/Avatar/BaseAvatar.vue'

export default {
  name: 'FuneralHomeAvatar',
  components: { BaseAvatar },
  props: {
    id: {
      type: String,
      required: true
    },
    ringColor: {
      type: String,
      required: false,
      default: null
    },
    shadowColor: {
      type: String,
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: (value) =>
        ['extra-small', 'small', 'medium', 'large', 'extra-large'].indexOf(
          value
        ) !== -1
    }
  },
  computed: {
    ...mapGetters({
      getFuneralHome: 'metadata/getFuneralHomeMetadata'
    }),
    funeralHome() {
      return this.getFuneralHome(this.id)
    }
  }
}
</script>
